/**
 * toolBarを広告主用に変更
 */
export const setToolbarTypeAdvertiser = {
  created() {
    this.$store.dispatch('toolbar/DISP_SETTING_BUTTON')
    this.$store.dispatch('toolbar/DISP_ACCOUNT_SETTING_BUTTON')
    this.$store.dispatch('toolbar/DISP_NOTIFICATION_BUTTON')
    // TODO: この２つはコンポーネントから小さく切り替える必要がある
    // なぜならレポートと運用で出し分けが必要になるから
    this.$store.dispatch('toolbar/HIDE_IO_SELECT_BUTTON')
    this.$store.dispatch('toolbar/SET_ADV_SELECT_BUTTON', { visible: true })
  },
}
